export const TIMELINE_TYPES = {
  39: "sales_stage",
  47: "reminder",
  106: "checklist",
  110: "callLogOrManualCall"
}

export const getType = type => TIMELINE_TYPES[type] || undefined
